<template>
  <LinkExpired title="Invitation link has expired :(">
    <p>The link you are trying to use has expired.</p>
    <p>Please contact the person who sent you the invitation to Easy Agency to request a new one.</p>

    <template #button>
      <b-button tag="a" :href="exploreButtonHref" target="_blank" class="button mt-4" variant="primary">
        Explore EasyAgency
      </b-button>
    </template>
  </LinkExpired>
</template>

<script>
import LinkExpired from '@components/sign-up/LinkExpired.vue'

export default {
  name: 'InvitationLinkExpired',
  components: { LinkExpired },
  data () {
    return {
      exploreButtonHref: process.env.VUE_APP_LANDING_PAGE
    }
  }
}
</script>
